export const enums = {
  SINGLE_LINE_HIGHLIGHT_CLASS: 'editableArea--single-line',
  MULTI_LINE_HIGHLIGHT_CLASS: 'editableArea--multi-line'
}
export default enums;